export const formatPrice = (price) => {
    var formattedPrice = '$' + price;
    if (price.indexOf('.') > -1) {
        if (price.split('.')[1].length == 1) formattedPrice += '0';
    } else formattedPrice += '.00';
    return formattedPrice;
};
